/* Visor de catalogos hojeables — Socadin
   Desktop: doble pagina, volteo 3D sobre el lomo.
   Movil:   una pagina, deslizamiento con swipe.
   Las paginas son imagenes WebP: no hay PDF que descargar. */
(function () {
  "use strict";

  var RATIO = 612 / 792;        /* carta vertical */
  var FLIP_MS = 700;
  var SLIDE_MS = 420;
  var EASE = "cubic-bezier(.42,0,.2,1)";
  var DESKTOP_MIN = 1000;
  var ZOOM_MAX = 3;
  var HIRES_AT = 1.5;           /* a partir de este zoom pedimos la imagen completa */
  var FULL_W = 1600;
  var FOCUSABLE = 'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';

  var ICONS = {
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    prev: '<path d="M15 5l-7 7 7 7"/>',
    next: '<path d="M9 5l7 7-7 7"/>',
    zoomIn: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5M11 8v6M8 11h6"/>',
    zoomOut: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5M8 11h6"/>',
    store: '<path d="M3 9l1.5-5h15L21 9M3 9h18M3 9v10a1 1 0 001 1h16a1 1 0 001-1V9M9 13h6"/>'
  };

  function svg(path) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function Flipbook(root) {
    this.root = root;
    this.cat = null;
    this.spread = 0;
    this.busy = false;
    this.zoom = 1;
    this.hiRes = false;
    this.pan = { x: 0, y: 0 };
    this.cache = {};
    this.manifest = null;
    this.anim = null;
    this.leaf = null;
    this._mode = null;
    this.pageW = 0;
    this.pageH = 0;
    this.build();
  }

  /* ------------------------------------------------------------ armado */

  Flipbook.prototype.build = function () {
    var self = this;
    var r = this.root;

    var bar = el("div", "sdn-fb__bar");
    this.titleEl = el("h2", "sdn-fb__title");
    this.countEl = el("span", "sdn-fb__count");
    this.zoomBtn = el("button", "sdn-fb__btn", svg(ICONS.zoomIn));
    this.zoomBtn.setAttribute("aria-label", "Acercar");
    this.closeBtn = el("button", "sdn-fb__btn", svg(ICONS.close));
    this.closeBtn.setAttribute("aria-label", "Cerrar el visor");
    bar.appendChild(this.titleEl);
    bar.appendChild(this.countEl);
    bar.appendChild(this.zoomBtn);
    bar.appendChild(this.closeBtn);

    this.stage = el("div", "sdn-fb__stage");
    this.viewport = el("div", "sdn-fb__viewport");
    this.book = el("div", "sdn-fb__book");
    this.left = el("div", "sdn-fb__slot sdn-fb__slot--left", "<img alt=\"\">");
    this.right = el("div", "sdn-fb__slot sdn-fb__slot--right", "<img alt=\"\">");
    this.book.appendChild(this.left);
    this.book.appendChild(this.right);
    this.viewport.appendChild(this.book);
    this.stage.appendChild(this.viewport);

    this.prevBtn = el("button", "sdn-fb__nav sdn-fb__nav--prev", svg(ICONS.prev));
    this.prevBtn.setAttribute("aria-label", "Pagina anterior");
    this.nextBtn = el("button", "sdn-fb__nav sdn-fb__nav--next", svg(ICONS.next));
    this.nextBtn.setAttribute("aria-label", "Pagina siguiente");
    this.stage.appendChild(this.prevBtn);
    this.stage.appendChild(this.nextBtn);

    this.foot = el("div", "sdn-fb__foot");
    this.thumbs = el("div", "sdn-fb__thumbs");
    var actions = el("div", "sdn-fb__actions");
    this.cta = el("a", "sdn-fb__cta", svg(ICONS.store) + "<span>Ver estos productos en la tienda</span>");
    this.hint = el("span", "sdn-fb__hint", "Doble click para acercar · flechas del teclado para hojear");
    this.toggle = el("button", "sdn-fb__toggle", "Ocultar miniaturas");
    actions.appendChild(this.cta);
    actions.appendChild(this.hint);
    actions.appendChild(this.toggle);
    this.foot.appendChild(this.thumbs);
    this.foot.appendChild(actions);

    this.live = el("div", "sdn-fb__live");
    this.live.setAttribute("role", "status");
    this.live.setAttribute("aria-live", "polite");

    r.appendChild(bar);
    r.appendChild(this.stage);
    r.appendChild(this.foot);
    r.appendChild(this.live);
    r.setAttribute("role", "dialog");
    r.setAttribute("aria-modal", "true");
    r.setAttribute("aria-label", "Visor de catalogo");

    this.closeBtn.addEventListener("click", function () { self.close(); });
    this.prevBtn.addEventListener("click", function () { self.turn(-1); });
    this.nextBtn.addEventListener("click", function () { self.turn(1); });
    this.zoomBtn.addEventListener("click", function () { self.setZoom(self.zoom > 1 ? 1 : 2.2); });
    this.toggle.addEventListener("click", function () { self.toggleThumbs(); });

    r.addEventListener("contextmenu", function (e) { e.preventDefault(); });
    r.addEventListener("dragstart", function (e) { e.preventDefault(); });

    this.stage.addEventListener("dblclick", function (e) { self.onDblClick(e); });
    this.bindKeys();
    this.bindDrag();
    this.bindWheel();

    var pending = false;
    window.addEventListener("resize", function () {
      if (pending || !self.cat) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; self.layout(); });
    });
  };

  /* -------------------------------------------------------- manifiesto */

  Flipbook.prototype.load = function () {
    var self = this;
    if (this.manifest) return Promise.resolve(this.manifest);
    if (this._loading) return this._loading;
    this._loading = fetch(this.root.getAttribute("data-manifest"))
      .then(function (r) { return r.json(); })
      .then(function (j) { self.manifest = j.catalogos; return self.manifest; })
      .catch(function (e) { self._loading = null; throw e; });
    return this._loading;
  };

  /* ------------------------------------------------------- abrir/cerrar */

  Flipbook.prototype.open = function (slug, page) {
    var self = this;
    return this.load().then(function (list) {
      var cat = null;
      for (var i = 0; i < list.length; i++) if (list[i].slug === slug) cat = list[i];
      if (!cat) return;

      if (self.cat !== cat) self.cache = {};
      self.cat = cat;
      self.hiRes = false;
      self.pan = { x: 0, y: 0 };
      self.titleEl.textContent = cat.title;
      self.cta.setAttribute("href", "/collections/" + cat.collection);
      self.buildThumbs();

      self._mode = self.mode();
      var start = Math.min(Math.max(parseInt(page, 10) || 1, 1), cat.pages);
      self.spread = self.spreadOf(start);

      if (!self.root.classList.contains("is-open")) {
        self.lastFocus = document.activeElement;
      }
      self.root.classList.add("is-open");
      document.body.classList.add("sdn-fb-lock");
      self.layout();
      self.setZoom(1);
      self.render();
      requestAnimationFrame(function () {
        self.root.classList.add("is-visible");
        self.layout();
        self.closeBtn.focus();
      });
      self.syncUrl();
    });
  };

  Flipbook.prototype.close = function () {
    var self = this;
    this.cancelFlip();
    this.busy = false;
    this.root.classList.remove("is-visible");
    document.body.classList.remove("sdn-fb-lock");
    setTimeout(function () { self.root.classList.remove("is-open"); }, 260);
    this.cat = null;
    history.replaceState({}, "", window.location.pathname);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Flipbook.prototype.cancelFlip = function () {
    if (this.anim) { try { this.anim.cancel(); } catch (e) {} this.anim = null; }
    if (this.leaf && this.leaf.parentNode) this.leaf.parentNode.removeChild(this.leaf);
    this.leaf = null;
  };

  Flipbook.prototype.syncUrl = function () {
    if (!this.cat) return;
    history.replaceState({}, "",
      window.location.pathname + "?cat=" + this.cat.slug + "&p=" + this.currentPage());
  };

  /* --------------------------------------------------------- geometria */

  Flipbook.prototype.mode = function () {
    return window.innerWidth >= DESKTOP_MIN ? "d" : "m";
  };

  /* En desktop una "spread" agrupa las paginas 2i (izquierda) y 2i+1 (derecha).
     La spread 0 muestra solo la portada a la derecha, como un libro real.
     En movil cada spread es una sola pagina. */
  Flipbook.prototype.spreadCount = function (m) {
    if (!this.cat) return 0;
    return (m || this.mode()) === "d" ? Math.floor(this.cat.pages / 2) + 1 : this.cat.pages;
  };

  Flipbook.prototype.spreadOf = function (page, m) {
    return (m || this.mode()) === "d" ? Math.floor(page / 2) : page - 1;
  };

  Flipbook.prototype.pagesAt = function (i, m) {
    if ((m || this.mode()) !== "d") return [0, i + 1 <= this.cat.pages ? i + 1 : 0];
    var l = 2 * i, r = 2 * i + 1;
    return [l >= 1 && l <= this.cat.pages ? l : 0, r <= this.cat.pages ? r : 0];
  };

  Flipbook.prototype.currentPage = function (m) {
    var p = this.pagesAt(this.spread, m);
    return p[1] || p[0] || 1;
  };

  /* Shopify sirve la imagen al ancho que le pidamos: no bajamos 1600px
     para pintarlos en un hueco de 500. Al ampliar sí pedimos el original. */
  Flipbook.prototype.url = function (page) {
    if (!page || !this.cat) return "";
    var u = this.cat.page_urls[page - 1];
    if (!u) return "";
    var w = FULL_W;
    if (!this.hiRes) {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = Math.min(FULL_W, Math.ceil((this.pageW || 700) * dpr / 200) * 200);
    }
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  };

  Flipbook.prototype.layout = function () {
    if (!this.cat) return;

    var m = this.mode();
    var changed = this._mode && this._mode !== m;
    if (changed) {
      var pg = this.currentPage(this._mode);
      this.spread = this.spreadOf(pg, m);
    }
    this._mode = m;
    var desktop = m === "d";
    this.root.classList.toggle("sdn-fb--single", !desktop);

    var cs = getComputedStyle(this.stage);
    var availW = this.stage.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var availH = this.stage.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var cols = desktop ? 2 : 1;

    var h = Math.max(80, Math.min(availH, availW / cols / RATIO));
    var w = h * RATIO;
    this.pageW = Math.floor(w);
    this.pageH = Math.floor(h);

    var px = this.pageW + "px", py = this.pageH + "px";
    this.left.style.width = px; this.left.style.height = py;
    this.right.style.width = px; this.right.style.height = py;
    this.left.style.display = desktop ? "" : "none";
    if (this.leaf) { this.leaf.style.width = px; this.leaf.style.height = py; }

    if (this.spread >= this.spreadCount()) this.spread = this.spreadCount() - 1;
    if (this.spread < 0) this.spread = 0;

    this.applyZoom();
    if (changed) { this.cancelFlip(); this.busy = false; this.render(); this.syncUrl(); }
  };

  /* ---------------------------------------------------------- pintado */

  Flipbook.prototype.setSlot = function (slot, page, silent) {
    var img = slot.querySelector("img");
    slot.classList.toggle("is-blank", !page);
    if (!page) { img.removeAttribute("src"); img.alt = ""; return; }
    img.src = this.url(page);
    img.alt = silent ? "" : "Pagina " + page + " del catalogo " + this.cat.title;
  };

  Flipbook.prototype.render = function () {
    if (!this.cat) return;
    var p = this.pagesAt(this.spread);
    this.setSlot(this.left, p[0]);
    this.setSlot(this.right, p[1]);
    this.updateChrome();
    this.preload();
  };

  Flipbook.prototype.updateChrome = function () {
    if (!this.cat) return;
    var p = this.pagesAt(this.spread);
    var label = (this._mode === "d" && p[0] && p[1]) ? p[0] + "–" + p[1] : String(p[1] || p[0]);
    this.countEl.textContent = label + " / " + this.cat.pages;
    this.live.textContent = "Pagina " + label + " de " + this.cat.pages;

    var atStart = this.spread <= 0, atEnd = this.spread >= this.spreadCount() - 1;
    /* si el boton enfocado se va a deshabilitar, movemos el foco antes */
    if (document.activeElement === this.prevBtn && atStart) this.nextBtn.focus();
    else if (document.activeElement === this.nextBtn && atEnd) this.prevBtn.focus();
    this.prevBtn.disabled = atStart;
    this.nextBtn.disabled = atEnd;

    var cur = this.thumbs.querySelector(".is-current");
    if (cur) { cur.classList.remove("is-current"); cur.removeAttribute("aria-current"); }
    var t = this.thumbs.children[this.currentPage() - 1];
    if (t) {
      t.classList.add("is-current");
      t.setAttribute("aria-current", "true");
      if (t.scrollIntoView) t.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
    }
  };

  Flipbook.prototype.preload = function () {
    if (!this.cat) return;
    var span = this._mode === "d" ? 2 : 3;
    var keys = Object.keys(this.cache);
    if (keys.length > 60) { for (var j = 0; j < 30; j++) delete this.cache[keys[j]]; }
    for (var i = this.spread - span; i <= this.spread + span; i++) {
      if (i < 0 || i >= this.spreadCount()) continue;
      var pages = this.pagesAt(i);
      for (var k = 0; k < 2; k++) {
        var u = this.url(pages[k]);
        if (u && !this.cache[u]) {
          var im = new Image();
          if (i !== this.spread) im.fetchPriority = "low";
          im.src = u;
          this.cache[u] = im;
        }
      }
    }
  };

  Flipbook.prototype.buildThumbs = function () {
    var self = this;
    this.thumbs.innerHTML = "";
    var frag = document.createDocumentFragment();
    for (var i = 1; i <= this.cat.pages; i++) {
      var b = el("button", "sdn-fb__thumb");
      b.setAttribute("aria-label", "Ir a la pagina " + i);
      var im = el("img");
      im.loading = "lazy";
      im.src = this.cat.thumb_urls[i - 1];
      im.alt = "";
      b.appendChild(im);
      (function (page) {
        b.addEventListener("click", function () { self.goTo(page); });
      })(i);
      frag.appendChild(b);
    }
    this.thumbs.appendChild(frag);
    this.foot.classList.remove("is-collapsed");
    this.toggle.textContent = "Ocultar miniaturas";
  };

  Flipbook.prototype.toggleThumbs = function () {
    var self = this;
    var hidden = this.foot.classList.toggle("is-collapsed");
    this.toggle.textContent = hidden ? "Mostrar miniaturas" : "Ocultar miniaturas";
    this.toggle.setAttribute("aria-expanded", hidden ? "false" : "true");
    setTimeout(function () { self.layout(); }, 300);
  };

  /* ------------------------------------------------------------ volteo */

  Flipbook.prototype.goTo = function (page) {
    if (this.busy || !this.cat) return;
    var target = this.spreadOf(page);
    if (target === this.spread) return;
    var dir = target > this.spread ? 1 : -1;
    if (this.zoom > 1) this.setZoom(1);
    this.spread = target;
    if (this._mode === "d") this.render(); else this.slide(dir);
    this.syncUrl();
  };

  Flipbook.prototype.turn = function (dir) {
    if (this.busy || !this.cat) return;
    var next = this.spread + dir;
    if (next < 0 || next >= this.spreadCount()) return;
    if (this.zoom > 1) this.setZoom(1);
    this.spread = next;
    if (this._mode === "d") this.flip(dir); else this.slide(dir);
    this.syncUrl();
  };

  /* Desktop. Al avanzar, la hoja de la derecha rota sobre el lomo hasta
     quedar a la izquierda: su cara frontal es la pagina que estaba a la
     derecha y su reverso es la nueva pagina izquierda. */
  Flipbook.prototype.flip = function (dir) {
    var self = this;
    var i = this.spread;                    /* spread destino */
    var from = i - dir;                     /* spread de origen */
    var fromP = this.pagesAt(from);
    var toP = this.pagesAt(i);

    var frontPage, backPage;
    if (dir > 0) { frontPage = fromP[1]; backPage = toP[0]; }
    else { frontPage = toP[1]; backPage = fromP[0]; }

    var leaf = el("div", "sdn-fb__leaf");
    leaf.setAttribute("aria-hidden", "true");
    leaf.style.width = this.pageW + "px";
    leaf.style.height = this.pageH + "px";
    var front = el("div", "sdn-fb__face sdn-fb__face--front", "<img alt=\"\">");
    var back = el("div", "sdn-fb__face sdn-fb__face--back", "<img alt=\"\">");
    front.appendChild(el("div", "sdn-fb__shade"));
    back.appendChild(el("div", "sdn-fb__shade"));
    this.setSlot(front, frontPage, true);
    this.setSlot(back, backPage, true);
    leaf.appendChild(front);
    leaf.appendChild(back);
    this.book.appendChild(leaf);
    this.leaf = leaf;

    /* Debajo de la hoja ya dejamos lista la cara que quedara descubierta. */
    if (dir > 0) this.setSlot(this.right, toP[1]);
    else this.setSlot(this.left, toP[0]);

    this.busy = true;
    var a = dir > 0 ? 0 : -180;
    var b = dir > 0 ? -180 : 0;
    var opts = { duration: FLIP_MS, easing: EASE, fill: "forwards" };

    var anim = leaf.animate(
      [{ transform: "rotateY(" + a + "deg)" }, { transform: "rotateY(" + b + "deg)" }], opts);
    front.querySelector(".sdn-fb__shade").animate(
      dir > 0 ? [{ opacity: 0 }, { opacity: 0.6 }] : [{ opacity: 0.6 }, { opacity: 0 }], opts);
    back.querySelector(".sdn-fb__shade").animate(
      dir > 0 ? [{ opacity: 0.6 }, { opacity: 0 }] : [{ opacity: 0 }, { opacity: 0.6 }], opts);
    this.anim = anim;

    var done = function () {
      if (self.anim !== anim) return;        /* ya lo cancelo close() o un cambio de modo */
      self.anim = null;
      if (leaf.parentNode) leaf.parentNode.removeChild(leaf);
      self.leaf = null;
      self.busy = false;
      self.render();
    };
    if (anim.finished) anim.finished.then(done, function () {});
    else anim.onfinish = done;
  };

  /* Movil: una pagina que entra deslizandose. */
  Flipbook.prototype.slide = function (dir) {
    var self = this;
    this.busy = true;
    this.setSlot(this.right, this.pagesAt(this.spread)[1]);
    var a = this.right.animate(
      [{ opacity: 0, transform: "translateX(" + (dir * 42) + "px)" },
       { opacity: 1, transform: "translateX(0)" }],
      { duration: SLIDE_MS, easing: "cubic-bezier(.22,.61,.36,1)" });
    this.anim = a;
    var done = function () {
      if (self.anim !== a) return;
      self.anim = null;
      self.busy = false;
      self.updateChrome();
      self.preload();
    };
    if (a.finished) a.finished.then(done, function () {});
    else a.onfinish = done;
  };

  /* -------------------------------------------------------------- zoom */

  Flipbook.prototype.setZoom = function (z, origin) {
    var before = this.hiRes;
    this.zoom = Math.min(Math.max(z, 1), ZOOM_MAX);
    if (this.zoom === 1) this.pan = { x: 0, y: 0 };
    else if (origin) this.pan = origin;
    this.hiRes = this.zoom >= HIRES_AT;
    this.zoomBtn.innerHTML = svg(this.zoom > 1 ? ICONS.zoomOut : ICONS.zoomIn);
    this.zoomBtn.setAttribute("aria-label", this.zoom > 1 ? "Alejar" : "Acercar");
    this.applyZoom();
    /* al ampliar cambiamos a la imagen completa para que se lean las tablas */
    if (this.hiRes !== before && this.cat && !this.busy) {
      var p = this.pagesAt(this.spread);
      this.setSlot(this.left, p[0]);
      this.setSlot(this.right, p[1]);
    }
  };

  Flipbook.prototype.applyZoom = function () {
    this.clampPan();
    this.viewport.style.transform =
      "translate(" + this.pan.x + "px," + this.pan.y + "px) scale(" + this.zoom + ")";
    this.stage.style.cursor = this.zoom > 1 ? "grab" : "";
  };

  Flipbook.prototype.clampPan = function () {
    if (this.zoom <= 1) { this.pan = { x: 0, y: 0 }; return; }
    var bw = this.book.offsetWidth * this.zoom, bh = this.book.offsetHeight * this.zoom;
    var mx = Math.max(0, (bw - this.stage.clientWidth) / 2 + 20);
    var my = Math.max(0, (bh - this.stage.clientHeight) / 2 + 20);
    this.pan.x = Math.min(Math.max(this.pan.x, -mx), mx);
    this.pan.y = Math.min(Math.max(this.pan.y, -my), my);
  };

  Flipbook.prototype.onDblClick = function (e) {
    if (e.target.closest(".sdn-fb__nav")) return;
    if (this.zoom > 1) return this.setZoom(1);
    var r = this.stage.getBoundingClientRect();
    var z = 2.2;
    this.setZoom(z, {
      x: (r.left + r.width / 2 - e.clientX) * (z - 1),
      y: (r.top + r.height / 2 - e.clientY) * (z - 1)
    });
  };

  Flipbook.prototype.bindWheel = function () {
    var self = this;
    this.stage.addEventListener("wheel", function (e) {
      if (!e.ctrlKey) return;
      e.preventDefault();
      self.setZoom(self.zoom * (e.deltaY < 0 ? 1.12 : 0.89), self.pan);
    }, { passive: false });
  };

  /* --------------------------------------------------- arrastre y swipe */

  Flipbook.prototype.bindDrag = function () {
    var self = this, start = null, moved = false, pinch = null, swallow = false;

    function dist(t) {
      var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function reset() { start = null; pinch = null; moved = false; self.viewport.classList.remove("is-dragging"); }

    this.stage.addEventListener("touchstart", function (e) {
      if (e.touches.length >= 2) {
        pinch = { d: dist(e.touches), z: self.zoom };
        start = null;              /* un pinch nunca debe voltear pagina */
        swallow = true;
        return;
      }
      if (swallow) return;
      start = { x: e.touches[0].clientX, y: e.touches[0].clientY, px: self.pan.x, py: self.pan.y };
      moved = false;
    }, { passive: true });

    this.stage.addEventListener("touchmove", function (e) {
      if (pinch && e.touches.length >= 2) {
        e.preventDefault();
        self.setZoom(pinch.z * (dist(e.touches) / pinch.d), self.pan);
        return;
      }
      if (!start) return;
      var dx = e.touches[0].clientX - start.x, dy = e.touches[0].clientY - start.y;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
      if (self.zoom > 1) {
        e.preventDefault();
        self.pan = { x: start.px + dx, y: start.py + dy };
        self.viewport.classList.add("is-dragging");
        self.applyZoom();
      }
    }, { passive: false });

    this.stage.addEventListener("touchend", function (e) {
      self.viewport.classList.remove("is-dragging");
      if (e.touches.length === 0) { pinch = null; }
      if (swallow) { if (e.touches.length === 0) swallow = false; start = null; return; }
      if (!start || !moved || self.zoom > 1) { start = null; return; }
      var dx = e.changedTouches[0].clientX - start.x;
      var dy = e.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) self.turn(dx < 0 ? 1 : -1);
      start = null;
    });

    this.stage.addEventListener("touchcancel", function () { swallow = false; reset(); });

    /* arrastre con mouse solo cuando hay zoom */
    this.stage.addEventListener("mousedown", function (e) {
      if (self.zoom <= 1) return;
      e.preventDefault();
      start = { x: e.clientX, y: e.clientY, px: self.pan.x, py: self.pan.y };
      self.stage.style.cursor = "grabbing";
    });
    window.addEventListener("mousemove", function (e) {
      if (!start || self.zoom <= 1) return;
      self.pan = { x: start.px + (e.clientX - start.x), y: start.py + (e.clientY - start.y) };
      self.viewport.classList.add("is-dragging");
      self.applyZoom();
    });
    window.addEventListener("mouseup", function () {
      if (!start) return;
      start = null;
      self.viewport.classList.remove("is-dragging");
      self.stage.style.cursor = self.zoom > 1 ? "grab" : "";
    });
  };

  Flipbook.prototype.trapFocus = function (e) {
    var items = [].slice.call(this.root.querySelectorAll(FOCUSABLE))
      .filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!this.root.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  };

  Flipbook.prototype.bindKeys = function () {
    var self = this;
    document.addEventListener("keydown", function (e) {
      if (!self.cat || !self.root.classList.contains("is-open")) return;
      if (e.key === "Escape") { self.close(); }
      else if (e.key === "Tab") { self.trapFocus(e); }
      else if (e.key === "ArrowRight") { e.preventDefault(); self.turn(1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); self.turn(-1); }
      else if (e.key === "Home") { e.preventDefault(); self.goTo(1); }
      else if (e.key === "End") { e.preventDefault(); self.goTo(self.cat.pages); }
      else if (e.key === "+" || e.key === "=") { self.setZoom(self.zoom * 1.25, self.pan); }
      else if (e.key === "-") { self.setZoom(self.zoom / 1.25, self.pan); }
    });
  };

  /* ------------------------------------------------------------- arranque */

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.getElementById("sdn-flipbook");
    if (!root) return;
    var fb = new Flipbook(root);
    window.sdnFlipbook = fb;

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-flipbook]");
      if (!trigger) return;
      e.preventDefault();
      fb.open(trigger.getAttribute("data-flipbook"), trigger.getAttribute("data-page") || 1);
    });

    var q = new URLSearchParams(window.location.search);
    if (q.get("cat")) fb.open(q.get("cat"), q.get("p") || 1);
  });
})();
